<script setup lang="ts">
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import NavItem from './NavItem.vue';
import { type NavbarIcon } from './types';

defineProps<{
    title: string;
    to?: string;
    href?: string;
    icon?: NavbarIcon;
}>();
const slots = useSlots();
const hasSubItems = computed(() => !!slots.default);
</script>

<template>
    <NavItem
        :title
        :to
        :href
        :icon
        position="sidebar"
        icon-default-color="var(--gray-800)"
    >
        <template #expand="{ expanded }">
            <mr-button
                v-if="hasSubItems"
                :aria-label="title"
                class="caret"
                :icon-button="{
                    icon: !expanded ? faChevronDown : faChevronUp,
                    color: 'black',
                }"
                variant="transparent"
                size="small"
            />
        </template>
        <template v-if="hasSubItems" #default>
            <slot />
        </template>
    </NavItem>
</template>

<style scoped lang="scss">
:slotted(.caret) {
    margin-right: auto;
    transition: transform 0.3s;
    display: flex;
}
</style>
